import { useEffect, useRef } from 'react'

export const useSSE = ({
  url,
  token,
  profileId,
  onMessage
}) => {
  const onMessageRef = useRef(onMessage)
  onMessageRef.current = onMessage

  useEffect(() => {
    if (!token || !profileId) return () => {}

    const controller = new AbortController()

    const connect = async () => {
      try {
        const response = await fetch(url, {
          headers: { Authorization: `Bearer ${token}` },
          signal: controller.signal
        })

        if (!response.ok) {
          console.error(`SSE connection failed: ${response.status}`)
          return
        }

        const reader = response.body.getReader()
        const decoder = new TextDecoder()
        let buffer = ''

        // eslint-disable-next-line no-constant-condition
        while (true) {
          // eslint-disable-next-line no-await-in-loop
          const { value, done } = await reader.read()
          if (done) break

          buffer += decoder.decode(value, { stream: true })
          const parts = buffer.split('\n\n')
          buffer = parts.pop()

          for (const part of parts) {
            const line = part.split('\n').find((l) => l.startsWith('data: '))
            if (line) {
              try {
                const payload = JSON.parse(line.slice(6))
                onMessageRef.current(payload)
              } catch (error) {
                console.error('Invalid SSE payload:', error)
              }
            }
          }
        }
      } catch (err) {
        if (err.name === 'AbortError') return
        console.error('SSE stream error:', err.message)
      }
    }

    connect()

    return () => {
      controller.abort()
    }
  }, [url, token, profileId])
}
